import { APIROOT } from './configs';

export const ReplaceValue = (columnType, objectId) => {
  let obj = columnType.find((o) => o.id === objectId);
  /// Placeholder to prevent Datagrid Error
  if (obj === undefined) {
    return 'Refreshing';
  } else {
    return obj.name;
  }
};

export async function getData(uriID, Body) {
  let JWT = localStorage.getItem('JWT_Key');
  let headers = {
    'content-type': 'application/JSON',
  };
  if (JWT) {
    headers['x-api-key'] = JWT;
  }
  let body = Body;
  const request = new Request(`${APIROOT}/api/${uriID}`, {
    method: 'post',
    headers,
    body: JSON.stringify(body),
  });
  const response = await fetch(request);
  const data = response.json();
  return data;
}

export function getCabinetType(config) {
  const {
    setCabinetTypesFunc, //Function to set cabinet data
    resource, //URI of Resource
    showNotification, //Function to enque notification
    logout, //Function to log user out in case of expired JWT
    // setColumnFunc,
  } = config;
  setCabinetTypesFunc([]);
  // setLoadingFunc(true);
  let payload = {
    pagereq: {},
  };
  //Get JWT from storage
  let JWT = localStorage.getItem('JWT_Key');

  //Set default Headers
  let headers = {
    'content-type': 'application/JSON',
  };
  //Set JWT in header if available
  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  const request = new Request(`${APIROOT}${resource}`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(payload),
  });

  fetch(request)
    .then((data) => {
      if (data.status === 200) {
        return data.text();
      } else {
        throw new Error(`Invalid Response`);
      }
    })
    .then((data) => {
      var parsed = JSON.parse(data);
      if (parsed.success === true) {
        setCabinetTypesFunc(parsed.data.value.rows);
        if (parsed.JWT) {
          localStorage.setItem('JWT_Key', parsed.JWT);
        }
      } else {
        if (parsed.message === 'Please login') {
          logout(() => {
            showNotification('Session Expired', 'warning');
          });
        } else {
          showNotification(parsed.message, 'error');
        }
      }
      // setLoadingFunc(false);
    })
    .catch((error) => {
      console.log(error);
      // setLoadingFunc(false);
      showNotification(
        typeof error == 'string' ? error : 'Connection Error',
        'error'
      );
    });
}

export function CustomerConstants(config) {
  const {
    setCategoriesFunc, //Function to set categories data
    setRegionsFunc, //Function to set categories data
    setAsset_compFunc, //Function to set categories data
    // setLoadingFunc, //Function to set loading on datagrid (set bool)
    resource, //URI of Resource
    showNotification, //Function to enque notification
    logout, //Function to log user out in case of expired JWT
    // setColumnFunc,
  } = config;
  setCategoriesFunc([]);
  setRegionsFunc([]);
  setAsset_compFunc([]);
  // setLoadingFunc(true);
  let payload = {
    pagereq: {},
  };
  //Get JWT from storage
  let JWT = localStorage.getItem('JWT_Key');

  //Set default Headers
  let headers = {
    'content-type': 'application/JSON',
  };
  //Set JWT in header if available
  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  const request = new Request(`${APIROOT}${resource}`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(payload),
  });

  fetch(request)
    .then((data) => {
      if (data.status === 200) {
        return data.text();
      } else {
        throw new Error(`Invalid Response`);
      }
    })
    .then((data) => {
      var parsed = JSON.parse(data);
      if (parsed.success === true) {
        setCategoriesFunc(parsed.data.value.categories);
        setRegionsFunc(parsed.data.value.regions);
        setAsset_compFunc(parsed.data.value.asset_comp);
        // setColumnFunc(parsed.data.value.columns);
        if (parsed.JWT) {
          localStorage.setItem('JWT_Key', parsed.JWT);
        }
      } else {
        if (parsed.message === 'Please login') {
          logout(() => {
            showNotification('Session Expired', 'warning');
          });
        } else {
          showNotification(parsed.message, 'error');
        }
      }
      // setLoadingFunc(false);
    })
    .catch((error) => {
      console.log(error);
      // setLoadingFunc(false);
      showNotification(
        typeof error == 'string' ? error : 'Connection Error',
        'error'
      );
    });
}

export function TableUpdate(config) {
  const {
    setDataFunc, //Function to set data returned
    pageNum, //Page requested
    setLoadingFunc, //Function to set loading on datagrid (set bool)
    pagesize, //Number of rows on page
    sorting, //Sorting model
    filtering, //Filtering model
    setRows, //Set total rows function
    resource, //URI of Resource
    showNotification, //Function to enque notification
    logout, //Function to log user out in case of expired JWT
    setColumnFunc,
    fullFilterCabinetType,
  } = config;
  setDataFunc([]);
  // setColumnFunc([]);
  setLoadingFunc(true);
  let payload = {
    pagereq: {
      filter: {
        sort: sorting,
        quickfilter:
          typeof filtering === 'object' ? filtering.join(' ') : undefined,
        fullfilter: [
          {
            field: 'name',
            search: fullFilterCabinetType,
            strict: false,
          },
        ],
      },
      page: pageNum,
      rowsperpage: pagesize,
    },
  };
  //Get JWT from storage
  let JWT = localStorage.getItem('JWT_Key');

  //Set default Headers
  let headers = {
    'content-type': 'application/JSON',
  };
  //Set JWT in header if available
  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  const request = new Request(`${APIROOT}${resource}`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(payload),
  });
  // console.log(JSON.stringify(payload, null, '\t'));
  fetch(request)
    .then((data) => {
      if (data.status === 200) {
        return data.text();
      } else {
        throw new Error(`Invalid Response`);
      }
    })
    .then((data) => {
      var parsed = JSON.parse(data);
      if (parsed.success === true) {
        setRows(parsed.data.totalrows ? parsed.data.totalrows : 0);
        setDataFunc(parsed.data.value.rows);
        setColumnFunc(
          parsed.data.value.columns
            ? parsed.data.value.columns
            : [
                {
                  field: 'serial_number',
                  headerName: 'Cabinet Type',
                  flex: 1,
                  width: 220,
                  editable: true,
                },
              ]
        );
        if (parsed.JWT) {
          localStorage.setItem('JWT_Key', parsed.JWT);
        }
      } else {
        if (parsed.message === 'Please login') {
          logout(() => {
            showNotification('Session Expired', 'warning');
          });
        } else {
          showNotification(parsed.message, 'error');
        }
      }
      setLoadingFunc(false);
    })
    .catch((error) => {
      // console.log(error);
      setLoadingFunc(false);
      showNotification(
        typeof error == 'string' ? error : 'Connection Error',
        'error'
      );
    });
}

export function NoHeaderTableUpdate(config, filterReq) {
  const {
    setDataFunc, //Function to set data returned
    pageNum, //Page requested
    setLoadingFunc, //Function to set loading on datagrid (set bool)
    pagesize, //Number of rows on page
    sorting, //Sorting model
    filtering, //Filtering model
    setRows, //Set total rows function
    resource, //URI of Resource
    showNotification, //Function to enque notification
    logout, //Function to log user out in case of expired JWT
    // setColumnFunc,
    // -- OPTIONAL -- //
    fullFilterName,
    fullFilterStoreName,
    fullFilterCategory,
    fullFilterRegion,
    fullFilterCabinetType,
    rangeFilterDateStart,
    rangeFilterDateEnd,
    type,
    code,
    description,
    byName,
    bySurname,
    byUserName,
    action,
  } = config;
  setDataFunc([]);
  setLoadingFunc(true);
  let payload;
  let blobReq = filterReq;

  switch (blobReq) {
    case 'customers':
      payload = {
        pagereq: {
          filter: {
            sort: sorting,
            quickfilter:
              typeof filtering === 'object' ? filtering.join(' ') : undefined,
            fullfilter: [
              {
                field: 'region',
                search: fullFilterRegion,
                strict: true,
              },
              {
                field: 'category',
                search: fullFilterCategory,
                strict: true,
              },
              {
                field: 'name',
                search: fullFilterName,
                strict: false,
              },
            ],
          },
          page: pageNum,
          rowsperpage: pagesize,
        },
      };
      break;
    case 'consumables':
      payload = {
        pagereq: {
          filter: {
            sort: sorting,
            quickfilter: filtering[0],
            fullfilter: [
              {
                field: 'type',
                search: type,
                strict: true,
              },
              {
                field: 'code',
                search: code,
                strict: false,
              },
              {
                field: 'description',
                search: description,
                strict: false,
              },
            ],
          },
          page: pageNum,
          rowsperpage: pagesize,
        },
      };
      break;
    case 'constants':
      payload = {
        pagereq: {
          filter: {
            sort: sorting,
            quickfilter: filtering[0],
            fullfilter: [
              {
                field: 'field',
                search: type,
                strict: true,
              },
              {
                field: 'name',
                search: byName,
                strict: false,
              },
            ],
          },
          page: pageNum,
          rowsperpage: pagesize,
        },
      };
      break;
    case 'serial':
      payload = {
        pagereq: {
          filter: {
            sort: sorting,
            quickfilter:
              typeof filtering === 'object' ? filtering.join(' ') : undefined,
            fullfilter: [
              {
                field: 'store_region_name',
                search: fullFilterRegion,
                strict: true,
              },
              {
                field: 'store_category_guid',
                search: fullFilterCategory,
                strict: true,
              },
              {
                field: 'store_name',
                search: fullFilterStoreName,
                strict: false,
              },
              {
                field: 'cabinet_name',
                search: fullFilterCabinetType,
                strict: true,
              },
            ],
            rangefilter: [
              {
                field: 'install_date',
                start: rangeFilterDateStart,
                stop: rangeFilterDateEnd,
              },
            ],
          },
          page: pageNum,
          rowsperpage: pagesize,
        },
      };
      // console.log(payload);
      break;

    case 'r2_users':
      payload = {
        pagereq: {
          filter: {
            sort: sorting,
            quickfilter: filtering[0],
            fullfilter: [
              {
                field: 'type',
                search: type,
                strict: true,
              },
              {
                field: 'username',
                search: byUserName,
                strict: false,
              },
              // {
              //   field: 'name',
              //   search: byName,
              //   strict: false,
              // },
            ],
          },
          page: pageNum,
          rowsperpage: pagesize,
        },
      };
      break;
    case 'r2_timelines':
      payload = {
        pagereq: {
          filter: {
            sort: sorting,
            quickfilter: filtering[0],
            fullfilter: [
              {
                field: 'tech_username',
                search: byUserName,
                strict: true,
              },
            ],
            rangefilter: [
              {
                field: 'start_time',
                start: rangeFilterDateStart,
                stop: rangeFilterDateEnd,
              },
              {
                field: 'stop_time',
                start: rangeFilterDateStart,
                stop: null, //rangeFilterDateEnd -- To be tested
              },
            ],
          },
          page: pageNum,
          rowsperpage: pagesize,
        },
      };
      break;

    case 'actions':
      payload = { action };
      break;

    default:
      payload = {
        pagereq: {
          filter: {
            sort: sorting,
            quickfilter: filtering[0],
          },
          page: pageNum,
          rowsperpage: pagesize,
        },
      };
      break;
  }

  let JWT = localStorage.getItem('JWT_Key');

  //Set default Headers
  let headers = {
    'content-type': 'application/JSON',
  };
  //Set JWT in header if available
  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  const request = new Request(`${APIROOT}${resource}`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(payload),
  });
  // console.log(JSON.stringify(payload, null, '\t'));
  fetch(request)
    .then((data) => {
      if (data.status === 200) {
        return data.text();
      } else {
        throw new Error(`Invalid Response`);
      }
    })
    .then((data) => {
      var parsed = JSON.parse(data);
      if (parsed.success === true) {
        setRows(parsed.data.totalrows ? parsed.data.totalrows : 0);
        setDataFunc(parsed.data.value);
        // setColumnFunc(parsed.data.value.columns);
        if (parsed.JWT) {
          localStorage.setItem('JWT_Key', parsed.JWT);
        }
      } else {
        if (parsed.message === 'Please login') {
          logout(() => {
            showNotification('Session Expired', 'warning');
          });
        } else {
          showNotification(parsed.message, 'error');
        }
      }
      setLoadingFunc(false);
    })
    .catch((error) => {
      console.log(error);
      setLoadingFunc(false);
      showNotification(
        typeof error == 'string' ? error : 'Connection Error',
        'error'
      );
    });
}
// blobProperty,
export const updateData = (
  uri,
  dataBlob,
  cancelEdit,
  setForceUpdate,
  // navigateBack,
  path,
  logout,
  enqNotification
) => {
  const DataBlob = dataBlob;

  //Get JWT from storage
  let JWT = localStorage.getItem('JWT_Key');
  //Set default Headers
  let headers = {
    'content-type': 'application/JSON',
  };
  //Set JWT in header if available
  if (JWT) {
    headers['x-api-key'] = JWT;
  }
  let body = {};

  body = dataBlob;
  // body = { constant: DataBlob };
  const request = new Request(`${APIROOT}/api${uri}`, {
    method: 'post',
    headers,
    body: JSON.stringify(body),
  });

  fetch(request)
    .then((response) => {
      if (response.status === 200) {
        return response.text();
      } else {
        throw new Error(`Failed to save new data`);
      }
    })
    .then((data) => {
      let parsed = JSON.parse(data);
      if (parsed.success === true) {
        setForceUpdate((val) => val + 1);
        //Update JWT if required
        if (parsed.JWT) {
          localStorage.setItem('JWT_Key', parsed.JWT);
        }

        cancelEdit();
        // navigateBack(`${path}`, { replace: true });
      } else {
        //Force logout
        if (parsed.message === 'Please login') {
          logout(() => {
            enqNotification('Session Expired', 'warning');
          });
        } else {
          enqNotification(parsed.message, 'error');
        }
      }
    })
    .catch((error) => {
      enqNotification(
        typeof error == 'string' ? error : 'Connection Error',
        'error'
      );
    });
};

/*Login User */
/**
 * Returns: {
 *  status: "" -> bool
 *  message: "" -> msg
 * }
 */
export function LoginUser(username, password, callback) {
  let creds = {
    username: username,
    password: password,
  };
  //Set default Headers
  let headers = {
    'content-type': 'application/JSON',
  };
  const request = new Request(`${APIROOT}/api/login/`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(creds),
  });
  fetch(request)
    .then((data) => {
      if (data.status === 200) {
        return data.text();
      } else {
        throw new Error(`Invalid Response`);
      }
    })
    .then((data) => {
      let parsed = JSON.parse(data);
      localStorage.clear();
      if (
        parsed.success === true &&
        parsed.JWT &&
        parsed.userdetails.active === '1'
      ) {
        localStorage.setItem('JWT_Key', parsed.JWT);
        localStorage.setItem('type', parsed.userdetails.type);
        localStorage.setItem('user', parsed.userdetails.permissions.username);
        // localStorage.setItem(
        //   'SuperAdmin',
        //   parsed.userdetails.permissions.super_admin
        // );
        // localStorage.setItem('Manager', parsed.userdetails.permissions.manager);
        // localStorage.setItem(
        //   'Supervisor',
        //   parsed.userdetails.permissions.supervisor
        // );
        // localStorage.setItem(
        //   'Finance',
        //   parsed.userdetails.permissions.supervisor
        // );
        // localStorage.setItem(
        //   'Controller',
        //   parsed.userdetails.permissions.finance
        // );
        // localStorage.setItem(
        //   'Technician',
        //   parsed.userdetails.permissions.technician
        // );
      }
      callback({ status: parsed.success, message: parsed.message });
    })
    .catch((error) => {
      callback({
        status: false,
        message: typeof error == 'string' ? error : 'Connection Error',
      });
    });
}
